import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-14',
  templateUrl: './14.component.html',
})
export class VbList14Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
